type StorefrontPublicPricingSource = {
  mostrar_precos?: unknown
  mostrarPrecos?: unknown
  site_mostrar_precos?: unknown
  siteMostrarPrecos?: unknown
  cliente_pior_cenario_id?: unknown
  clientePiorCenarioId?: unknown
  site_cliente_pior_cenario_id?: unknown
  siteClientePiorCenarioId?: unknown
} | null | undefined

const normalizePositiveInteger = (value: unknown): number | null => {
  const parsed = Number(value)
  if (!Number.isFinite(parsed) || parsed <= 0) return null
  return Math.trunc(parsed)
}

export const isShowPricesBeforeLoginEnvEnabled = (): boolean =>
  import.meta.env.VITE_SHOW_PRICES_BEFORE_LOGIN === '1'

export const resolveStorefrontPublicPricingClienteId = (
  source: StorefrontPublicPricingSource
): number | null => {
  if (!source) return null
  return normalizePositiveInteger(
    source.cliente_pior_cenario_id
    ?? source.clientePiorCenarioId
    ?? source.site_cliente_pior_cenario_id
    ?? source.siteClientePiorCenarioId
  )
}

export const resolveStorefrontPublicPricingEnabled = (
  source: StorefrontPublicPricingSource
): boolean =>
  isShowPricesBeforeLoginEnvEnabled()
  && resolveStorefrontPublicPricingClienteId(source) !== null

const storefrontPublicPricingContext: {
  enabled: boolean
  entidadeId: number | undefined
} = {
  enabled: false,
  entidadeId: undefined,
}

export function configureStorefrontPublicPricing(source: StorefrontPublicPricingSource) {
  const entidadeId = resolveStorefrontPublicPricingClienteId(source)
  storefrontPublicPricingContext.enabled = resolveStorefrontPublicPricingEnabled(source)
  storefrontPublicPricingContext.entidadeId = storefrontPublicPricingContext.enabled && entidadeId
    ? entidadeId
    : undefined
}

export function getStorefrontPublicPricingEntidadeId(): number | undefined {
  return storefrontPublicPricingContext.enabled
    ? storefrontPublicPricingContext.entidadeId
    : undefined
}

export function isStorefrontPublicPricingEntidadeId(value: unknown): boolean {
  const entidadeId = normalizePositiveInteger(value)
  return storefrontPublicPricingContext.enabled
    && entidadeId !== null
    && entidadeId === storefrontPublicPricingContext.entidadeId
}
